module.exports = __webpack_public_path__ + "static/media/medium.493fe78f.svg";